import _ from "lodash"
import React, { useState, useEffect } from "react"
import { bindActionCreators } from "redux"
import { connect } from "react-redux"
import NumberField from "components/NumberField"
import ReactSelect from "components/ReactSelect"
import DateAndTimePicker from "components/DateAndTimePicker"
import { Field } from "formik"
import { loadingStatus, getPayload } from "actions"
import helpers from "helpers/helpers"
import classNames from "classnames"
import HTMLEditor from "components/HTMLEditor"
import currentUser from "helpers/currentUser"
import DateField from "components/DateField"

const TableRowField = (props) => {
	const [store, setStore] = useState(null)
	const [user] = useState(currentUser())
	const [ready, setReady] = useState(true)
	//? Ready was put in place for messaging where you can hide/show history, then you can also sort.  The keys were getting mixed up, so the ready logic just forces a complete re-render.
	//? presetRows is for when we pass in a preset amount of rows that they have to edit like the fees table that's preset per community.  This also disables the add row button.

	useEffect(() => {
		if (props.presets) {
			try {
				let newStore = []
				// The first field is the value field which is the name of this fee here
				let fieldName = props.presets.fields[0].name
				_.forEach(props.presets.presets, (v) => {
					if (props.presets.property && v.properties.indexOf(props.presets.property) == -1) return
					let model = {}
					model[fieldName] = v.name
					_.forEach(props.presets.fields, (f) => {
						if (f.name == fieldName) return
						let val = null
						if (v?.preset && f.name === v?.preset?.id) {
							val = v.preset.value
						}
						model[f.name] = val
					})
					newStore.push(model)
				})
				setStore(newStore)
			} catch (e) {
				console.log(e)
			}
		} else if (props.initRow) {
			addRow()
		}
	}, [])

	useEffect(() => {
		if (!props.data || props.data.length == 0) return // new, this was put in to prevent infinite refreshing
		if (!_.isEqual(props.data, store)) {
			//console.log(props.data, store)
			console.log("Building Data...")
			buildData()
		}
	}, [props.data])

	useEffect(() => {
		buildFinalResponse()
	}, [store])

	useEffect(() => {
		if (!ready) {
			setReady(true)
		}
	}, [ready])

	const buildData = () => {
		setReady(false)
		let newStore = _.cloneDeep(props.data)
		if (!newStore) newStore = []
		_.forEach(newStore, (v, k) => {
			_.forEach(v, (r, key) => {
				if (typeof r == "string" && parseInt(r) && !helpers.hasNonNumericChars(r)) {
					newStore[k][key] = parseInt(r)
				}
			})
		})
		setStore(newStore)
	}

	const buildFinalResponse = () => {
		props.onChange(store)
	}

	const handleChange = (v, k, name) => {
		try {
			let newStore = _.cloneDeep(store)
			newStore[k][name] = v
			setStore(newStore)
		} catch (e) {
			console.log(e)
		}
	}

	const addRow = () => {
		let newStore = _.clone(store)
		if (!newStore) newStore = []
		let model = {}
		_.forEach(props.fields, (v) => {
			model[v.name] = null
		})
		if (props.appendUser) model.user = user.id
		newStore.push(model)
		setStore(newStore)
	}

	const sort = (name) => {
		let newStore = _.cloneDeep(store)
		newStore = _.sortBy(newStore, [name])
		setStore(newStore)
		setReady(false)
	}

	const buildHeaders = () => {
		let ret = []
		_.forEach(props.fields, (v) => {
			ret.push(
				<th
					key={`${props.name}-${v.header}`}
					onClick={() => sort(v.name)}
					className={classNames(`cursor-pointer`, {
						"text-left": props.align == "left",
						"text-center": props.align === "center",
					})}>
					{v.header}{" "}
					{v.selectAll ? (
						<>
							<br />
							<a
								className="text-blue text-xs font-normal cursor-pointer"
								onClick={() => {
									let newStore = _.cloneDeep(store)
									_.forEach(newStore, (r, k) => {
										newStore[k][v.name] = !newStore[k][v.name]
									})
									setStore(newStore)
									buildFinalResponse()
								}}>
								Select All
							</a>
						</>
					) : null}
				</th>
			)
		})
		return ret
	}

	const buildOptions = (v, val) => {
		if (v.dependent) {
			let ret = []
			_.forEach(props.payload.public[v.lookup], (r) => {
				if (v.dependentVal) {
					if (r.property !== v.dependentVal) return
				} else if (r.property !== val.property) return
				ret.push({
					label: r.name,
					value: r.id,
				})
			})
			return ret
		}
		if (v.options) return v.options
		return _.map(props.payload.public[v.lookup], (v) => {
			return {
				label: v.name,
				value: v.id,
			}
		})
	}

	const removeRow = (k) => {
		let newStore = _.cloneDeep(store)
		newStore.splice(k, 1)
		setStore(newStore)
		buildFinalResponse()
	}

	const buildRows = () => {
		let ret = []
		_.forEach(store, (val, k) => {
			let s = []
			_.forEach(props.fields, (v) => {
				let field
				if (v.type == "select") {
					field = (
						<ReactSelect
							keyVal={`${props.name}-${k}-${v.name}`}
							name={`${k}`}
							options={buildOptions(v, val)}
							value={store[k][v.name]}
							onBlur={() => {}}
							onChange={(old, val) => handleChange(val, k, v.name)}
							isMulti={v.isMulti}
							clearable={v.clearable}
							placeholder={v.placeholder}
							allowNull={props.allowNull}
						/>
					)
				} else if (v.type == "number") {
					field = (
						<NumberField
							key={`${props.name}-${k}-${v.name}`}
							name={store[k][v.name]}
							value={store[k][v.name]}
							type="text"
							className="form__input"
							onChange={(old, val) => handleChange(val, k, v.name)}
							thousandSeparator={true}
							numeric={v.float ? false : true}
							onBlur={() => {}}
							float={v.float}
							decimals={v.decimals}
						/>
					)
				} else if (v.type == "text") {
					field = (
						<Field
							key={`${props.name}-${k}-${v.name}`}
							name={store[k][v.name]}
							value={store[k][v.name]}
							type="text"
							className="form__input"
							onChange={(val) => {
								handleChange(val.target.value, k, v.name)
							}}
						/>
					)
				} else if (v.type == "checkbox") {
					field = (
						<Field
							key={`${props.name}-${k}-${v.name}`}
							name={store[k][v.name]}
							checked={store[k][v.name]}
							type="checkbox"
							className="form__input"
							onChange={(e) => {
								let value = e.target.checked
								handleChange(value, k, v.name)
							}}
						/>
					)
				} else if (v.type == "datetimepicker") {
					field = (
						<DateAndTimePicker
							key={`${props.name}-${k}-${v.name}`}
							name={store[k][v.name]}
							value={store[k][v.name]}
							onChange={(name, val) => {
								handleChange(val, k, v.name)
							}}
							//fixed={true} // Commented out due to open houses in lot inventory, if scrolled down, it would have the picker off screen..?
						/>
					)
				} else if (v.type == "date") {
					field = (
						<DateField
							key={`${props.name}-${k}-${v.name}`}
							id={`${k}-${v.name}`}
							name={store[k][v.name]}
							value={store[k][v.name]}
							onChange={(name, val) => {
								handleChange(val, k, v.name)
							}}
							onBlur={() => {}}
						/>
					)
				} else if (v.type == "textarea") {
					field = (
						<Field
							key={`${props.name}-${k}-${v.name}`}
							name={store[k][v.name]}
							value={store[k][v.name] || ""}
							component="textarea"
							className="form__input"
							onChange={(val) => {
								handleChange(val.target.value, k, v.name)
							}}
						/>
					)
				} else if (v.type == "html") {
					field = (
						<HTMLEditor
							key={`${props.name}-${k}-${v.name}`}
							name={store[k][v.name]}
							className="form__textarea"
							value={store[k][v.name] || ""}
							onChange={(param, value) => {
								handleChange(value, k, v.name)
							}}
							id={`${k}-${v.name}`}
							onBlur={() => {}}
						/>
					)
				} else if (v.type === "value") {
					field = <span key={`${props.name}-${k}-${v.name}`}>{val[v.name]}</span>
				}
				s.push(
					<td style={{ width: v.width }} key={`${props.name}-${k}-${v.name}`}>
						{field}
					</td>
				)
			})
			ret.push(
				<tr
					key={`${props.name}-${k}`}
					className={classNames(``, {
						hidden: val.tableRowFieldHide,
					})}>
					{s}
					{props.delete && (
						<td style={{ width: 20 }} key={`${k}-delete`}>
							<i
								className="fa fa-minus-circle"
								onClick={() => {
									removeRow(k)
								}}
							/>
						</td>
					)}
				</tr>
			)
		})
		return ret
	}
	if (!ready) {
		return ""
	}
	return (
		<div>
			<div>
				{!props.presets && (
					<p className="traffic__addMore" style={{ margin: 0 }}>
						<span onClick={() => addRow()}>
							<i className="fa fa-plus-circle" />
						</span>
					</p>
				)}
				<table className="inputTable padCells">
					<thead>
						<tr>{buildHeaders()}</tr>
					</thead>
					<tbody>{buildRows()}</tbody>
				</table>
			</div>
		</div>
	)
}

function mapStateToProps(state) {
	return {
		currentDates: state.currentDates,
		compareDates: state.compareDates,
		payload: state.payload,
		payloadStatus: state.payloadStatus,
		activeProperties: state.activeProperties,
	}
}

function matchDispatchToProps(dispatch) {
	return bindActionCreators(
		{
			loadingStatus,
			getPayload,
		},
		dispatch
	)
}

export default connect(mapStateToProps, matchDispatchToProps)(TableRowField)
